export default [{
  path: "/appList",
  name: "AppList",
  component: () => import(/* webpackChunkName: "AppList" */"@/views/AppList.vue")
}, {
  path: "/login",
  meta: {
    auth: false
  },
  name: "Login",
  component: () => import(/* webpackChunkName: "Login" */"@/views/Login.vue")
}, {
  path: "/regist",
  meta: {
    auth: false
  },
  name: "Regist",
  component: () => import(/* webpackChunkName: "Regist" */"@/views/Regist.vue")
}, {
  path: "/protocol",
  meta: {
    auth: false
  },
  name: "Protocol",
  component: () => import(/* webpackChunkName: "Protocol" */"@/views/Protocol.vue")
}, {
  path: "/bind",
  meta: {
    auth: false
  },
  name: "Bind",
  component: () => import(/* webpackChunkName: "Bind" */"@/views/Bind.vue")
}, {
  path: "/forget",
  meta: {
    auth: false
  },
  name: "Forget",
  component: () => import(/* webpackChunkName: "Forget" */"@/views/Forget.vue")
}, {
  path: "/join",
  meta: {
    auth: false
  },
  name: "Join",
  component: () => import(/* webpackChunkName: "Join" */"@/views/Join.vue")
}, {
  path: "/success",
  meta: {
    auth: false
  },
  name: "Success",
  component: () => import(/* webpackChunkName: "Success" */"@/views/Success.vue")
}, {
  path: "/openApp",
  meta: {
    auth: false
  },
  name: "OpenApp",
  component: () => import(/* webpackChunkName: "Success" */"@/views/OpenApp.vue")
}, {
  path: "/enterApp",
  meta: {
    auth: false
  },
  name: "enterApp",
  component: () => import(/* webpackChunkName: "Success" */"@/views/EnterApp.vue")
}, {
  name: "Invites",
  path: "/Invites",
  meta: {
    auth: false
  },
  component: () => import("@/views/Invite/Invite.vue")
}];